import React from 'react'
import { MdOutlineDelete } from 'react-icons/md'
import { CiEdit } from 'react-icons/ci'
import { Link } from 'react-router-dom'

const UserTable = ({ data, onDelete, userPermissions }) => {
  return (
    <div className='overflow-x-auto'>
      <table className='min-w-full table-auto border-collapse'>
        <thead>
          <tr className='bg-prime'>
            <th className='px-6 py-4 text-left  font-medium text-white'>
              Name
            </th>
            <th className='px-6 py-4 text-left  font-medium text-white'>
              Role
            </th>
            <th className='px-6 py-4 text-center  font-medium text-white'>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row) => (
              <tr key={row._id} className='border-b'>
                <td className='px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900'>
                  {row.email}
                </td>
                <td className='px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900'>
                  {row.role?.name}
                </td>
                {row.role?.name === 'Super Admin' ? null : (
                  <td className='px-6 py-4 flex justify-center items-center whitespace-nowrap text-sm font-medium text-white space-x-4'>
                    {userPermissions.includes('user:update') ? (
                      <Link
                        to={`/user/${row._id}`}
                        className='inline-block rounded-full p-1 border-2 border-transparent hover:bg-prime text-prime hover:text-white '
                      >
                        <CiEdit className='text-2xl' />
                      </Link>
                    ) : null}
                    {userPermissions.includes('user:delete') ? (
                      <button
                        onClick={() => onDelete(row._id)}
                        className='rounded-full p-1 border-2 border-transparent hover:bg-red-700 text-red-700 hover:text-white '
                      >
                        <MdOutlineDelete className='text-2xl' />
                      </button>
                    ) : null}

                    {!userPermissions.includes('user:update') &&
                      !userPermissions.includes('user:delete') && (
                        <p className='text-dark text-center'>No Access </p>
                      )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan='3' className='px-6 py-4 text-center text-white'>
                No users available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default UserTable
